export enum BusyMessage {
	Loading = 'Loading...',
	Saving = 'Saving...',
	Deleting = 'Deleting...',
	Calculating = 'Calculating...',
	Processing = 'Processing...',
	GeneratingReport = 'Generating Report...',
	GeneratingExcelFile = 'Generating Excel File...',
	GeneratingFile = 'Generating File...',
	SendingEmail = 'Sending Email...',
	Importing = 'Importing...',
	Exporting = 'Exporting...',
}
